import React from 'react';
import { LEGAL_URLS } from '../helpers/Constants';

const BottomMenu = () => {
  return (
    <footer className="bottom-0 left-0 right-0 bg-primary text-white py-2">
      <div className="container mx-auto flex justify-center">
        <ul className="md:flex space-x-4 space-y-2">
          <li className='ml-4 my-2'>
            <a href="https://trustymo.com/contactez-nous" target={"_blank"} className="hover:text-secondary transition duration-300">
              Contact
            </a>
          </li>
          <li>
            <a href={LEGAL_URLS.CGU} target={"_blank"} rel="noreferrer" className="hover:text-secondary transition duration-300">
              CGU
            </a>
          </li>
          <li>
            <a href={LEGAL_URLS.PRIVACY_POLICY} target={"_blank"} rel="noreferrer" className="hover:text-secondary transition duration-300">
              Politique de confidentialité
            </a>
          </li>
          <li>
            <a href={LEGAL_URLS.LEGAL_NOTICE} target={"_blank"} rel="noreferrer" className="hover:text-secondary transition duration-300">
              Mentions légales
            </a>
          </li>
          <p>@trustymo 2026</p>
        </ul>
      </div>
    </footer>
  );
};

export default BottomMenu;
